<main class="auth auth--centered">
  <section class="auth__panel auth__panel--wide">
    <div class="auth__card auth__card--centered">

      <span class="auth__mark-mobile">
        <svg width="44" height="44" viewBox="0 0 120 120" fill="none" aria-hidden="true">
          <defs>
            <clipPath id="frameToken"><rect x="28.5" y="20.5" width="63" height="79" rx="15.5"></rect></clipPath>
          </defs>
          <rect x="26" y="18" width="68" height="84" rx="18" stroke="#1F4B3F" stroke-width="4.5"></rect>
          <g clip-path="url(#frameToken)">
            <circle cx="46.5" cy="44" r="8.5" stroke="#C2A461" stroke-width="3.6"></circle>
            <path d="M27 83 L43 66 L52 72 L70 48 L93 83" stroke="#1F4B3F" stroke-width="4" stroke-linejoin="round" stroke-linecap="round"></path>
            <path d="M26 87 Q43 79 60 87 T95 87" stroke="#1F4B3F" stroke-width="3.6" stroke-linecap="round"></path>
            <path d="M26 96 Q45 87 62 96 T98 95" stroke="#C2A461" stroke-width="3.6" stroke-linecap="round"></path>
          </g>
        </svg>
      </span>

      <span class="auth__status auth__status--error" data-id="token-status" hidden><i class="icon icon--triangle-alert"></i></span>
      <p class="auth__eyebrow">SaaS Admin</p>
      <h2 class="auth__title" data-id="token-title"><%= _lcs( 'Link wird geprüft …' ) %></h2>
      <p class="auth__subtitle" data-id="token-text"><%= _lcs( 'Einen Moment bitte.' ) %></p>
      <p class="auth__error" data-id="token-error" role="alert" hidden></p>

      <a class="auth__link auth__back" href="#/login" data-id="btn-back-to-login" hidden>
        <i class="icon icon--arrow-left"></i>
        <%= _lcs( 'Zurück zur Anmeldung' ) %>
      </a>

      <div class="auth__hr"><%= _lcs( 'Geschützter Bereich' ) %></div>
      <p class="auth__note"><%= _lcs( 'BELTURO Cloud — Interner Operator-Zugang.' ) %></p>
    </div>
  </section>
</main>
